// src/components/Contact.js
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaInstagram, FaFacebook, FaEnvelope, FaPhone, FaWhatsapp } from "react-icons/fa";

function Contact() {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText("nairobisultimateexperience@gmail.com");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Jost:wght@300;400;500;600&display=swap');

        :root {
          --gold: #C9A84C;
          --gold-light: #E8C97A;
          --dark: #0A0A0A;
          --charcoal: #141414;
        }

        .contact-root {
          font-family: 'Jost', sans-serif;
          background: var(--dark);
          color: #fff;
          min-height: 100vh;
        }

        /* ── HERO ── */
        .contact-hero {
          background: linear-gradient(160deg, #0d0b06 0%, #1a1300 55%, #0A0A0A 100%);
          border-bottom: 1px solid rgba(201,168,76,0.2);
          padding: 5rem 1.5rem 3.5rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .contact-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 60% 50% at 50% 100%, rgba(201,168,76,0.07) 0%, transparent 70%);
          pointer-events: none;
        }
        .contact-eyebrow {
          font-size: 0.68rem;
          letter-spacing: 5px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.8rem;
        }
        .contact-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(2.8rem, 7vw, 4.5rem);
          font-weight: 700;
          color: #fff;
          line-height: 1.05;
          margin-bottom: 0.4rem;
        }
        .contact-title em {
          font-style: italic;
          color: var(--gold-light);
        }
        .contact-divider {
          width: 50px;
          height: 2px;
          background: var(--gold);
          margin: 1.2rem auto 1.5rem;
        }
        .contact-subtitle {
          font-size: clamp(0.88rem, 2vw, 1rem);
          font-weight: 300;
          color: rgba(255,255,255,0.6);
          max-width: 520px;
          margin: 0 auto;
          line-height: 1.8;
        }

        /* ── BODY ── */
        .contact-body {
          max-width: 1000px;
          margin: 0 auto;
          padding: 5rem 1.5rem 6rem;
        }

        /* ── CHANNEL CARDS ── */
        .channel-card {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(201,168,76,0.15);
          border-radius: 10px;
          padding: 2.5rem 2rem;
          text-align: center;
          height: 100%;
          transition: border-color 0.3s, transform 0.3s, background 0.3s;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .channel-card:hover {
          border-color: rgba(201,168,76,0.5);
          background: rgba(201,168,76,0.04);
          transform: translateY(-5px);
        }

        .channel-icon-wrap {
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: rgba(201,168,76,0.1);
          border: 1px solid rgba(201,168,76,0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.4rem;
          font-size: 1.5rem;
          color: var(--gold);
          transition: background 0.3s, border-color 0.3s;
        }
        .channel-card:hover .channel-icon-wrap {
          background: rgba(201,168,76,0.18);
          border-color: var(--gold);
        }

        .channel-label {
          font-size: 0.62rem;
          letter-spacing: 4px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.5rem;
          font-weight: 500;
        }
        .channel-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.5rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 1.2rem;
        }

        /* Action links/buttons inside cards */
        .channel-link {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          color: rgba(255,255,255,0.6);
          text-decoration: none;
          font-size: 0.85rem;
          font-weight: 400;
          transition: color 0.2s;
          margin-bottom: 0.5rem;
        }
        .channel-link:hover { color: var(--gold); }

        .channel-cta {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(201,168,76,0.1);
          border: 1px solid rgba(201,168,76,0.35);
          color: var(--gold-light);
          padding: 0.55rem 1.4rem;
          border-radius: 50px;
          font-size: 0.78rem;
          font-weight: 500;
          text-decoration: none;
          letter-spacing: 0.5px;
          transition: background 0.25s, border-color 0.25s, color 0.25s;
          cursor: pointer;
          font-family: 'Jost', sans-serif;
          margin-top: auto;
        }
        .channel-cta:hover {
          background: rgba(201,168,76,0.2);
          border-color: var(--gold);
          color: #fff;
        }

        /* Social icons row */
        .social-icons-row {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }
        .social-icon-btn {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          border: 1px solid rgba(201,168,76,0.3);
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          color: rgba(255,255,255,0.6);
          font-size: 1.15rem;
          text-decoration: none;
          transition: background 0.25s, border-color 0.25s, color 0.25s, transform 0.2s;
        }
        .social-icon-btn:hover {
          background: rgba(201,168,76,0.12);
          border-color: var(--gold);
          color: var(--gold);
          transform: scale(1.1);
        }

        /* ── BOTTOM BAND ── */
        .contact-band {
          border-top: 1px solid rgba(201,168,76,0.15);
          padding: 3.5rem 1.5rem;
          text-align: center;
          background: var(--charcoal);
        }
        .contact-band p {
          font-size: 0.88rem;
          color: rgba(255,255,255,0.45);
          margin: 0;
          line-height: 1.8;
        }
        .contact-band strong {
          color: var(--gold-light);
          font-weight: 500;
        }

        /* Copy toast */
        .copy-toast {
          display: inline-block;
          background: var(--gold);
          color: #0A0A0A;
          font-size: 0.72rem;
          font-weight: 600;
          letter-spacing: 1px;
          padding: 0.2rem 0.7rem;
          border-radius: 4px;
          margin-left: 0.5rem;
          animation: fadeInOut 2s ease forwards;
        }
        @keyframes fadeInOut {
          0%   { opacity:0; transform:translateY(-4px); }
          15%  { opacity:1; transform:translateY(0); }
          80%  { opacity:1; }
          100% { opacity:0; }
        }

        @media (max-width: 767px) {
          .channel-card { margin-bottom: 1rem; }
        }
      `}</style>

      <div className="contact-root">

        {/* ── HERO ── */}
        <div className="contact-hero">
          <p className="contact-eyebrow">Nairobi's Ultimate Experience</p>
          <h1 className="contact-title">Let's <em>Connect</em></h1>
          <div className="contact-divider" />
          <p className="contact-subtitle">
            Have questions, need a custom tour, or simply want to say hello?
            We're always ready to craft your next Nairobi adventure.
          </p>
        </div>

        {/* ── CHANNEL CARDS ── */}
        <div className="contact-body">
          <div className="row g-4 justify-content-center">

            {/* WhatsApp */}
            <div className="col-12 col-md-4">
              <div className="channel-card">
                <div className="channel-icon-wrap">
                  <FaWhatsapp />
                </div>
                <p className="channel-label">Instant Chat</p>
                <h2 className="channel-title">WhatsApp</h2>
                <p className="channel-link" style={{ color: "rgba(255,255,255,0.45)", fontSize: "0.83rem", marginBottom: "1.5rem" }}>
                  +254 105 057 005
                </p>
                <a
                  href="https://wa.me/254105057005"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="channel-cta"
                >
                  <FaWhatsapp size={13} /> Chat Now
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="col-12 col-md-4">
              <div className="channel-card">
                <div className="channel-icon-wrap">
                  <FaEnvelope />
                </div>
                <p className="channel-label">Write to Us</p>
                <h2 className="channel-title">Email</h2>
                <a
                  href="mailto:nairobisultimateexperience@gmail.com"
                  className="channel-link"
                  style={{ marginBottom: "1.5rem", wordBreak: "break-all" }}
                >
                  nairobisultimateexperience@gmail.com
                </a>
                <div style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap", justifyContent: "center", marginTop: "auto" }}>
                  <a
                    href="mailto:nairobisultimateexperience@gmail.com"
                    className="channel-cta"
                  >
                    <FaEnvelope size={12} /> Send Email
                  </a>
                  <button
                    onClick={copyEmail}
                    className="channel-cta"
                    style={{ border: "1px solid rgba(255,255,255,0.12)", color: "rgba(255,255,255,0.5)", background: "transparent" }}
                  >
                    {copied ? "✓ Copied!" : "Copy"}
                  </button>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="col-12 col-md-4">
              <div className="channel-card">
                <div className="channel-icon-wrap">
                  <FaPhone />
                </div>
                <p className="channel-label">Call Us</p>
                <h2 className="channel-title">Phone</h2>
                <a href="tel:+254105057005" className="channel-link" style={{ marginBottom: "1.5rem" }}>
                  +254 105 057 005
                </a>
                <a href="tel:+254105057005" className="channel-cta" style={{ marginTop: "auto" }}>
                  <FaPhone size={12} /> Call Now
                </a>
              </div>
            </div>

          </div>

          {/* Social row */}
          <div style={{ textAlign: "center", marginTop: "4rem" }}>
            <p style={{ fontSize: "0.65rem", letterSpacing: "4px", textTransform: "uppercase", color: "var(--gold)", marginBottom: "1.4rem" }}>
              Follow Our Journey
            </p>
            <div className="social-icons-row">
              <a
                href="https://www.instagram.com/nairobisultimate_citytours?igsh=MXd4aXJicXJ3aWZubg=="
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                title="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.facebook.com/NairobiUltimateExperience"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                title="Facebook"
              >
                <FaFacebook />
              </a>
              <a
                href="https://wa.me/254105057005"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon-btn"
                title="WhatsApp"
              >
                <FaWhatsapp />
              </a>
            </div>
            <p style={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.3)", letterSpacing: "0.5px" }}>
              @nairobisultimate_citytours
            </p>
          </div>
        </div>

        {/* ── BOTTOM BAND ── */}
        <div className="contact-band">
          <p>
            Based in <strong>Nairobi, Kenya</strong> · Available 7 days a week<br />
            Response time: <strong>within 2 hours</strong> during business hours
          </p>
        </div>

      </div>
    </>
  );
}

export default Contact;
